var _path, _path2, _g, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSnsNavertv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0155 22.4975C14.0208 22.8242 13.9598 23.1488 13.8362 23.4521C13.7125 23.7555 13.5287 24.0317 13.2953 24.2646C13.0619 24.4975 12.7837 24.6825 12.4768 24.8087C12.17 24.935 11.8406 25 11.5079 25C11.1752 25 10.8459 24.935 10.539 24.8087C10.2321 24.6825 9.95393 24.4975 9.72055 24.2646C9.48718 24.0317 9.30331 23.7555 9.17966 23.4521C9.05601 23.1488 8.99504 22.8242 9.00032 22.4975V9.50252C8.99504 9.17576 9.05601 8.85125 9.17966 8.54786C9.30331 8.24448 9.48718 7.9683 9.72055 7.73539C9.95393 7.50249 10.2321 7.31753 10.539 7.19127C10.8459 7.06502 11.1752 7 11.5079 7C11.8406 7 12.17 7.06502 12.4768 7.19127C12.7837 7.31753 13.0619 7.50249 13.2953 7.73539C13.5287 7.9683 13.7125 8.24448 13.8362 8.54786C13.9598 8.85125 14.0208 9.17576 14.0155 9.50252V22.4975Z",
    fill: "#CDD6E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8965 24.6046C12.6177 24.7767 12.3071 24.8932 11.9825 24.9473C11.6579 25.0015 11.3256 24.9923 11.0046 24.9204C10.6835 24.8484 10.3801 24.715 10.1116 24.5279C9.84304 24.3407 9.61466 24.1034 9.43948 23.8296C9.2643 23.5557 9.14575 23.2506 9.0906 22.9318C9.03545 22.6129 9.04477 22.2865 9.11804 21.9712C9.26601 21.3344 9.66547 20.7814 10.2285 20.4339L20.6577 13.9983C20.9365 13.8262 21.2471 13.7097 21.5717 13.6554C21.8963 13.6012 22.2287 13.6104 22.5497 13.6823C22.8707 13.7542 23.1742 13.8876 23.4428 14.0747C23.7114 14.2619 23.9398 14.4992 24.115 14.773C24.2902 15.0469 24.4088 15.3519 24.464 15.6708C24.5192 15.9897 24.5099 16.3161 24.4367 16.6315C24.3634 16.9468 24.2277 17.2449 24.0371 17.5087C23.8466 17.7725 23.6051 17.9969 23.3263 18.169L12.8965 24.6046Z",
    fill: "#CDD6E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5426 7.00391C11.8637 7.00819 12.1811 7.07301 12.4775 7.19495C12.7843 7.32121 13.0625 7.50617 13.2959 7.73907C13.5293 7.97197 13.7131 8.24816 13.8368 8.55154C13.9604 8.85493 14.0214 9.17944 14.0161 9.5062V13.8898L10.2285 11.5521C9.66548 11.2046 9.26602 10.6516 9.11805 10.0148C8.97008 9.37795 9.0857 8.70947 9.43949 8.15639C9.79328 7.60331 10.3563 7.21094 11.0046 7.06559C11.1825 7.02569 11.3629 7.0053 11.5426 7.00391Z",
    fill: "#CDD6E3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8965 7.38117C12.3334 7.03365 11.6529 6.92007 11.0046 7.06542C10.3563 7.21077 9.79328 7.60315 9.43949 8.15622C9.0857 8.7093 8.97008 9.37778 9.11805 10.0146C9.26602 10.6514 9.66548 11.2044 10.2285 11.5519L20.6558 17.9875C20.9347 18.1596 21.2453 18.276 21.5699 18.3302C21.8946 18.3844 22.2269 18.3752 22.5479 18.3032C22.869 18.2312 23.1724 18.0978 23.441 17.9106C23.7095 17.7234 23.9379 17.4861 24.1131 17.2122C24.2883 16.9383 24.4068 16.6332 24.462 16.3143C24.5171 15.9954 24.5078 15.6689 24.4345 15.3536C24.3612 15.0382 24.2253 14.7401 24.0348 14.4764C23.8442 14.2126 23.6026 13.9882 23.3238 13.8161L12.8965 7.38117Z",
    fill: "#CDD6E3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3.05518,
    y: 5.00391,
    width: 16.9614,
    height: 18.8857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsNavertv);
export default __webpack_public_path__ + "static/media/sns_navertv.77c253a089c0226f7af04660af2a97bd.svg";
export { ForwardRef as ReactComponent };